import React, { useState } from "react";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { FaTags, FaSave, FaTimes, FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";

const AddBrandForm = ({ onBack }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    contact_person: "",
    contact_email: "",
    contact_phone: "",
    address: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Brand Data:", formData);
    toast.success("Brand added successfully!");
    setFormData({
      name: "",
      description: "",
      contact_person: "",
      contact_email: "",
      contact_phone: "",
      address: ""
    });
    if (onBack) onBack();
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Card className="border-0 shadow-sm">
      <Card.Header className="bg-info text-white d-flex align-items-center">
        <FaTags className="me-2" />
        <h5 className="mb-0">Add Brand</h5>
        {onBack && (
          <Button
            variant="light"
            size="sm"
            className="ms-auto"
            onClick={onBack}
          >
            <FaArrowLeft className="me-1" />
            Back
          </Button>
        )}
      </Card.Header>
      <Card.Body className="p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Brand Name *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  required
                  className="form-control-lg"
                  placeholder="Enter brand name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Contact Person</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.contact_person}
                  onChange={(e) => handleChange('contact_person', e.target.value)}
                  className="form-control-lg"
                  placeholder="Enter contact person name"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Contact Email</Form.Label>
                <Form.Control
                  type="email"
                  value={formData.contact_email}
                  onChange={(e) => handleChange('contact_email', e.target.value)}
                  className="form-control-lg"
                  placeholder="Enter contact email"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Contact Phone</Form.Label>
                <Form.Control
                  type="tel"
                  value={formData.contact_phone}
                  onChange={(e) => handleChange('contact_phone', e.target.value)}
                  className="form-control-lg"
                  placeholder="Enter contact phone"
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.address}
              onChange={(e) => handleChange('address', e.target.value)}
              placeholder="Enter brand address..."
              className="form-control-lg"
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder="Enter brand description..."
              className="form-control-lg"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-3">
            {onBack && (
              <Button 
                variant="outline-secondary" 
                size="lg"
                onClick={onBack}
              >
                <FaTimes className="me-1" />
                Cancel
              </Button>
            )}
            <Button 
              variant="info" 
              type="submit" 
              size="lg"
              className="px-4"
            >
              <FaSave className="me-1" />
              Add Brand
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddBrandForm;
